import * as React from "react"
import {Box, Typography} from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";

export default function CustomDashboardsPrimorFlashOffersErrorPage({ errorCode }) {
    const boxStyles = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        padding: 3,
        textAlign: 'center',
        mt: 10
    }

    return <Box sx={boxStyles} >
        <IconSeeker icon={'server'} sx={{ fontSize: 50, color: 'text.secondary', mb: 1 }} />

        { errorCode === 'PRIMOR_EXCEL_FORMAT_ERROR' && <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'text.primary', mt: 1 }}>
            The Primor Excel file has a formatting error. Please review and correct the file.
        </Typography>}

        { errorCode === 'DRUNI_SCRAPING_ERROR' && <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'text.primary', mt: 1 }}>
            There was a failure while retrieving data from the Druni site.
        </Typography>}

        { errorCode === 'PRIMOR_OFFERS_ERROR' &&  <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'text.primary', mt: 1 }}>
            No flash offers were found in the feed. Please check the feed.
        </Typography>}

        { errorCode === 'UNKNOWN_ERROR' &&  <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'text.primary', mt: 1 }}>
            An unknown error occurred while generating the data.
        </Typography>}

        {(errorCode === 'UNKNOWN_ERROR' || errorCode === 'DRUNI_SCRAPING_ERROR') && <Typography variant="body2" sx={{ color: 'text.secondary',  mt: 1 }}>
            The technical team has been notified to review the incident.
        </Typography>}
    </Box>
}